import { render, staticRenderFns } from "./column-header.vue?vue&type=template&id=5b19a06c"
import script from "./column-header.vue?vue&type=script&lang=js"
export * from "./column-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b19a06c')) {
      api.createRecord('5b19a06c', component.options)
    } else {
      api.reload('5b19a06c', component.options)
    }
    module.hot.accept("./column-header.vue?vue&type=template&id=5b19a06c", function () {
      api.rerender('5b19a06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/column-header/column-header.vue"
export default component.exports